import {useEffect, useRef} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {jsonInit} from '../api/client';
import {useAuth, useMe} from './useAuth';

// Tells the server which time zone this phone is in, once per session when it differs, so an
// assistant can date a tell "2024-10-08" without an offset. Silent: nothing shows on failure.
export function useTimezoneSync() {
    const {call} = useAuth();
    const me = useMe();
    const queryClient = useQueryClient();
    const sent = useRef(false);

    useEffect(() => {
        if (!me.data || sent.current) return;
        let zone: string | undefined;
        try {
            zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch {
            return;
        }
        if (!zone || zone === me.data.timezone) return;
        sent.current = true;
        call('/api/auth/me', jsonInit('PUT', {timezone: zone}))
            .then(() => queryClient.invalidateQueries({queryKey: ['me']}))
            .catch(() => undefined);
    }, [me.data, call, queryClient]);
}
